import axiosInstance from "@/axiosInstance";

// Apre un documento del preventivo con la sessione dell'utente: l'API lo
// restituisce solo con il login, quindi il PDF arriva come blob e si apre
// con un URL blob: temporaneo, che non funziona fuori da questa sessione.

// Dopo questo tempo l'URL blob: non si apre più (la scheda già aperta resta)
const BLOB_URL_TTL_MS = 60 * 1000;
const openUrls = new Set();

const revoke = (url) => {
  URL.revokeObjectURL(url);
  openUrls.delete(url);
};

// Al logout: nessun URL blob: dei documenti resta apribile
export function revokeDocumentUrls() {
  openUrls.forEach(revoke);
}

export async function openDocument(doc) {
  // La scheda va aperta subito, nel click: dopo l'await il browser la bloccherebbe
  const win = window.open("", "_blank");
  try {
    const { data } = await axiosInstance.get(
      `/upload/documents/${encodeURIComponent(doc.name)}`,
      { responseType: "blob" }
    );
    const url = URL.createObjectURL(data);
    openUrls.add(url);
    setTimeout(() => revoke(url), BLOB_URL_TTL_MS);
    if (win) win.location.href = url;
    else window.location.href = url;
  } catch (err) {
    if (win) win.close();
    throw err;
  }
}
